import { useMemo } from 'react';
import type { Video } from '@/mocks/videos';
import { getRelativeDays } from '@/utils/format';

export const REFERENCE_DATE = '2026-10-12';

export interface VideoFilterState {
  subCategory: string;
  time: string;
  duration: string;
  sort: string;
}

export const defaultFilterState: VideoFilterState = {
  subCategory: 'all',
  time: 'all',
  duration: 'all',
  sort: 'latest',
};

export function useVideoFilter(source: Video[], filters: VideoFilterState) {
  return useMemo(() => {
    let list = [...source];

    if (filters.subCategory !== 'all') {
      list = list.filter((v) => v.subCategory === filters.subCategory);
    }

    if (filters.time !== 'all') {
      const days = Number(filters.time);
      list = list.filter((v) => getRelativeDays(v.uploadDate, REFERENCE_DATE) <= days);
    }

    if (filters.duration !== 'all') {
      list = list.filter((v) => {
        if (filters.duration === 'short') return v.duration <= 300;
        if (filters.duration === 'medium') return v.duration > 300 && v.duration <= 1200;
        if (filters.duration === 'long') return v.duration > 1200;
        return true;
      });
    }

    if (filters.sort === 'popular') {
      list.sort((a, b) => b.views - a.views);
    } else if (filters.sort === 'duration') {
      list.sort((a, b) => b.duration - a.duration);
    } else {
      list.sort((a, b) => (a.uploadDate < b.uploadDate ? 1 : -1));
    }

    return list;
  }, [source, filters.subCategory, filters.time, filters.duration, filters.sort]);
}